import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import { Provider } from 'react-redux';
import configureStore from './redux/store';
import App from './pages';
import reportWebVitals from './reportWebVitals';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

const permissionTree = sessionStorage.getItem('permissionTree') ? JSON.parse(sessionStorage.getItem('permissionTree')) : {}
const responsibleTree = sessionStorage.getItem('responsibleTree') ? JSON.parse(sessionStorage.getItem('responsibleTree')) : {}

const localUser = sessionStorage.getItem('user') || null
const localToken = sessionStorage.getItem('token')
const userID = sessionStorage.getItem('userID')
const username = sessionStorage.getItem('username')
const exten = sessionStorage.getItem('exten')
const sourceTree = sessionStorage.getItem('sourceTree') !== undefined ? JSON.parse(sessionStorage.getItem('sourceTree')) : {}
// const memberList = sessionStorage.getItem('memberList') !== undefined ? JSON.parse(sessionStorage.getItem('memberList')) : {}
const tabsList = sessionStorage.getItem('tabsList') ? JSON.parse(sessionStorage.getItem('tabsList')) : []
const activeKey = sessionStorage.getItem('activeKey')
const activeTab = sessionStorage.getItem('activeTab') ? JSON.parse(sessionStorage.getItem('activeTab')) : {}
const store = configureStore(
    {
      app: {
        count: 0,
        token: localToken,
        user: localUser,
        userID,
          username,
        exten,
        sourceTree,
        // permissionMap,
        permissionTree,
          responsibleTree,
        spinning: false,
      },
      menuInfo: {
        isShowMenu: true,
        tabsList,
        activeKey,
        activeTab
      },
    }
)
ReactDOM.render(
  // <React.StrictMode>
      <Provider store={store}>
        <ConfigProvider locale={zhCN}>
          <App />
        </ConfigProvider>
      </Provider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
